import { render, staticRenderFns } from "./PosOrderType.vue?vue&type=template&id=9c74b9ce"
import script from "./PosOrderType.vue?vue&type=script&lang=ts"
export * from "./PosOrderType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports